import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCitiesByPostCode',
  pure: false
})
export class FilterCitiesByPostCodePipe implements PipeTransform {

  transform(value: any, parentForm: any): any {
    const postCode = parentForm.get('postCode').value;
    if(postCode?.length > 3) {
    if(value && postCode ) {
      const cities = value.find(item => item.value === postCode).cities;
      if(cities.length > 1) {
        //parentForm.get('cityName').enable();
      } else {
        //parentForm.get('cityName').disable();
      }
      return cities;
    }
    //parentForm.get('cityName').disable();
    return null;
  }
}

}
